import React, { FC, memo, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { Drawer } from 'shared/ui/Drawer';
import { getDiscountFormState } from '../model/selectors/getDiscountFormState';
import { discountFormDrawerActions } from '../model/slice/discountFormDrawerSlice';
import { DiscountForm } from './DiscountForm';

export const DiscountFormDrawer: FC = memo(() => {
  const dispatch = useAppDispatch();

  const discountFormState = useAppSelector(getDiscountFormState);

  const closeDisocuntFormDrawer = useCallback((): void => {
    dispatch(discountFormDrawerActions.setOpenDiscountForm({ mode: null, discount: null }));
  }, [dispatch]);

  return (
    <Drawer width={550} open={Boolean(discountFormState.mode)} onClose={closeDisocuntFormDrawer}>
      <DiscountForm discount={discountFormState.discount} mode={discountFormState.mode} handleClose={closeDisocuntFormDrawer} />
    </Drawer>
  );
});
